import { createFileRoute } from "@tanstack/react-router";
import { PitchDeck } from "@/components/marketing/site/pitch/pitch-deck";
import { GENERAL_DECK } from "@/components/marketing/site/pitch/general-content";

/** The general demo deck, for any operator. Not indexed: it is a presenter's tool reached by link,
 * and the prices and returns on it are for the room. */
function DemoPitch() {
  return <PitchDeck content={GENERAL_DECK} />;
}

export const Route = createFileRoute("/v2/pitch/demo")({
  component: DemoPitch,
  head: () => ({
    meta: [
      { title: "Demo | PPL" },
      { name: "robots", content: "noindex,nofollow" },
      {
        name: "description",
        content: "A walkthrough of PPL: the AI workforce and operating system for senior living.",
      },
    ],
  }),
});
